const LESSON_TYPE_PREPOSITION = 'preposition_gap';
const LESSON_TYPE_NVV = 'verb_collocation';
const LESSON_TYPE_ARTICLE = 'article_gender';
const LESSON_TYPE_VERB_FORMS = 'verb_forms';
const LESSON_TYPE_FLASHCARD = 'flashcard';
const LESSON_TYPE_PRODUCTION = 'production';
const LESSON_TYPE_DIALOGUE = 'dialogue';
const LESSON_TYPE_RECOGNITION = 'recognition';

// `hex` below is the app's deliberate categorical palette for lesson types
// (one hue per track) and the single source for those colors — goalTypes and
// DailyStatsTab derive from it. Class strings spell the hex out literally so
// Tailwind's JIT scanner can generate them; chips use the same flat tint
// pattern as the rest of the app (bg /10 · text full · border /30).
export const getLessonTypeMeta = (lessonType) => {
  const t = lessonType || LESSON_TYPE_PRODUCTION;

  switch (t) {
    case LESSON_TYPE_PREPOSITION:
    case 'case_object':
    case 'object_gap':
      return {
        key: t,
        label: 'Objekte ◈',
        shortLabel: 'Objekte ◈',
        colorClasses: 'bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/30',
        dotClass: 'bg-[#3b82f6]',
        strongBgClass: 'bg-[#3b82f6]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#3b82f6',
      };
    case LESSON_TYPE_NVV:
      return {
        key: LESSON_TYPE_NVV,
        label: 'Nomen-Verb',
        shortLabel: 'Nomen-Verb',
        colorClasses: 'bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/30',
        dotClass: 'bg-[#a855f7]',
        strongBgClass: 'bg-[#a855f7]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#a855f7',
      };
    case LESSON_TYPE_ARTICLE:
      return {
        key: LESSON_TYPE_ARTICLE,
        label: 'Genus',
        shortLabel: 'Genus',
        colorClasses: 'bg-[#f59e0b]/10 text-[#f59e0b] border-[#f59e0b]/30',
        dotClass: 'bg-[#f59e0b]',
        strongBgClass: 'bg-[#f59e0b]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#f59e0b',
      };
    case LESSON_TYPE_VERB_FORMS:
      return {
        key: LESSON_TYPE_VERB_FORMS,
        label: 'Konjugation',
        shortLabel: 'Konjugation',
        colorClasses: 'bg-[#10b981]/10 text-[#10b981] border-[#10b981]/30',
        dotClass: 'bg-[#10b981]',
        strongBgClass: 'bg-[#10b981]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#10b981',
      };
    case LESSON_TYPE_FLASHCARD:
      return {
        key: LESSON_TYPE_FLASHCARD,
        label: 'Karteikarte',
        shortLabel: 'Karteikarte',
        colorClasses: 'bg-[#f43f5e]/10 text-[#f43f5e] border-[#f43f5e]/30',
        dotClass: 'bg-[#f43f5e]',
        strongBgClass: 'bg-[#f43f5e]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#f43f5e',
      };
    case LESSON_TYPE_RECOGNITION:
      return {
        key: LESSON_TYPE_RECOGNITION,
        label: 'Erkennen',
        shortLabel: 'Erkennen',
        colorClasses: 'bg-[#84cc16]/10 text-[#84cc16] border-[#84cc16]/30',
        dotClass: 'bg-[#84cc16]',
        strongBgClass: 'bg-[#84cc16]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#84cc16',
      };
    case LESSON_TYPE_DIALOGUE:
      return {
        key: LESSON_TYPE_DIALOGUE,
        label: 'Dialog',
        shortLabel: 'Dialog',
        colorClasses: 'bg-[#14b8a6]/10 text-[#14b8a6] border-[#14b8a6]/30',
        dotClass: 'bg-[#14b8a6]',
        strongBgClass: 'bg-[#14b8a6]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#14b8a6',
      };
    case 'reflexive':
      return {
        key: 'reflexive',
        label: 'Reflexiv ↻',
        shortLabel: 'Reflexiv ↻',
        colorClasses: 'bg-[#06b6d4]/10 text-[#06b6d4] border-[#06b6d4]/30',
        dotClass: 'bg-[#06b6d4]',
        strongBgClass: 'bg-[#06b6d4]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#06b6d4',
      };
    case 'plural':
      return {
        key: 'plural',
        label: 'Plural ⊞',
        shortLabel: 'Plural ⊞',
        colorClasses: 'bg-[#f97316]/10 text-[#f97316] border-[#f97316]/30',
        dotClass: 'bg-[#f97316]',
        strongBgClass: 'bg-[#f97316]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#f97316',
      };
    case 'genus':
      return {
        key: 'genus',
        label: 'Genus-Trainer',
        shortLabel: 'Genus-Tr.',
        colorClasses: 'bg-[#f59e0b]/10 text-[#f59e0b] border-[#f59e0b]/30',
        dotClass: 'bg-[#f59e0b]',
        strongBgClass: 'bg-[#f59e0b]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#f59e0b',
      };
    case 'plural_trainer':
      return {
        key: 'plural_trainer',
        label: 'Plural-Trainer ⊞',
        shortLabel: 'Plural-Tr. ⊞',
        colorClasses: 'bg-[#f97316]/10 text-[#f97316] border-[#f97316]/30',
        dotClass: 'bg-[#f97316]',
        strongBgClass: 'bg-[#f97316]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#f97316',
      };
    case LESSON_TYPE_PRODUCTION:
    default:
      return {
        key: LESSON_TYPE_PRODUCTION,
        label: 'Produktion',
        shortLabel: 'Produktion',
        colorClasses: 'bg-[#6366f1]/10 text-[#6366f1] border-[#6366f1]/30',
        dotClass: 'bg-[#6366f1]',
        strongBgClass: 'bg-[#6366f1]',
        strongHoverBgClass: 'hover:opacity-90',
        hex: '#6366f1',
      };
  }
};
